/* Equalises the title and description block heights across sibling
 * collection cards inside the same .resource-list--grid so that the
 * button row of every card lands on the same baseline at any width.
 *
 * Pure DOM/JS, no framework. Listens to resize, font load, and DOM
 * mutations on each grid so re-renders (variant updates, lazy images,
 * font swaps) trigger a re-measure. Each measured element is given an
 * explicit min-height equal to the tallest sibling's offsetHeight. */

const PART_SELECTORS = [
  ':scope > .text-block:not(.rte):first-of-type',
  ':scope > .rte',
];

const measuredKey = '__alignCardsMeasuring__';

function equaliseGrid(grid) {
  if (grid[measuredKey]) return;
  grid[measuredKey] = true;

  const cards = grid.querySelectorAll('.collection-card__content');
  if (cards.length < 2) {
    grid[measuredKey] = false;
    return;
  }

  for (const selector of PART_SELECTORS) {
    const els = [];
    cards.forEach((card) => {
      const el = card.querySelector(selector);
      if (el) {
        el.style.minHeight = '';
        els.push(el);
      }
    });
    if (els.length < 2) continue;
    // Force a reflow before measuring so cleared min-heights apply.
    void els[0].offsetHeight;
    const maxH = Math.max(...els.map((el) => el.offsetHeight));
    els.forEach((el) => {
      el.style.minHeight = `${maxH}px`;
    });
  }

  grid[measuredKey] = false;
}

function equaliseAll() {
  document.querySelectorAll('.resource-list--grid').forEach(equaliseGrid);
}

function debounce(fn, wait = 80) {
  let t;
  return () => {
    clearTimeout(t);
    t = setTimeout(fn, wait);
  };
}

const scheduleEqualise = debounce(equaliseAll, 80);

function setup() {
  equaliseAll();

  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(scheduleEqualise);
  }

  window.addEventListener('resize', scheduleEqualise);
  window.addEventListener('load', scheduleEqualise);

  // Watch for late-loaded grids (variant updates, hot reload, lazy images).
  const mo = new MutationObserver(scheduleEqualise);
  mo.observe(document.body, { childList: true, subtree: true });

  // Watch each grid's intrinsic size for column reflows.
  document.querySelectorAll('.resource-list--grid').forEach((grid) => {
    const ro = new ResizeObserver(scheduleEqualise);
    ro.observe(grid);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', setup, { once: true });
} else {
  setup();
}
